export const userRegions = [
  { value: "CHIHUAHUA", label: "Chihuahua" },
  { value: "CUAUHTEMOC", label: "Cuauhtémoc" },
  { value: "DELICIAS", label: "Delicias" },
  { value: "PARRAL", label: "Parral" },
  { value: "CENTRO_SUR", label: "Zona centro sur" }
]